:host {
  /**
  * @prop --title-font-family: The menu font family
  */
  --title-font-family: "Source Sans Pro", sans-serif;
  /**
  * @prop --title-text-transform: The menu text transform property
  */
  --title-text-transform: lowercase;
  /**
  * @prop --title-font-weight: The menu text font weight
  */
  --title-font-weight: bold;
  /**
  * @prop --first-list-font-size: The item font size for the first list items
  */
  --first-list-font-size: 14px;
  /**
  * @prop --second-list-font-size: The item font size for the second list items
  */
  --second-list-font-size: 14px;
  /**
  * @prop --third-list-font-size: The item font size for the third list items
  */
  --third-list-font-size: 14px;
  /**
  * @prop --first-list-line-height: The item line height for the first list items
  */
  --first-list-line-height: 1.4em;
  /**
  * @prop --second-list-line-height: The item line height for the second list items
  */
  --second-list-line-height: 1.4em;
  /**
  * @prop --third-list-line-height: The item line height for the third list items
  */
  --third-list-line-height: 1.4em;
  /**
  * @prop --first-list-text-transform: The item text transform for the first list items
  */
  --first-list-text-transform: capitalize;
  /**
  * @prop --second-list-text-transform: The item text transform for the second list items
  */
  --second-list-text-transform: lowercase;
  /**
  * @prop --third-list-text-transform: The item text transform for the third list items
  */
  --third-list-text-transform: capitalize;
  /**
  * @prop --first-list-text-vertical-padding: The vertical padding (top and bottom) for the first list items
  */
  --first-list-text-vertical-padding: 8px;
  /**
  * @prop --second-list-text-vertical-padding: The vertical padding (top and bottom) for the second list items
  */
  --second-list-text-vertical-padding: 6px;
  /**
  * @prop --third-list-text-vertical-padding: The vertical padding (top and bottom) for the third list items
  */
  --third-list-text-vertical-padding: 4px;
  /**
  * @prop --menu-background-color: The background color of the menu
  */
  --menu-background-color: var(--whiteSmoke);
  /**
  * @prop --text-color: The color of the text
  */
  --text-color: var(--black);
  /**
  * @prop --item-hover-color: The color of the item on hover
  */
  --item-hover-color: var(--lightGray);
  /**
  * @prop --item-active-color: The color of active item
  */
  --item-active-color: var(--silverGray);
  /**
  * @prop --first-list-icon-color: The color of the first list icon
  */
  --first-list-icon-color: var(--black);
  /**
  * @prop --first-list-arrow-color: The color of the first list arrow icon
  */
  --first-list-arrow-color: var(--black);
  /**
  * @prop --second-list-arrow-color: The color of the second list arrow icon
  */
  --second-list-arrow-color: var(--black);
  /**
  * @prop --footer-line: The color of the footer separator line
  */
  --footer-line-color: var(--black);
  /**
  * @prop --footer-font-size: The footer font size
  */
  --footer-font-size: 14px;
  /**
  * @prop --indicator-color: The color of the lateral indicator
  */
  --indicator-color: var(--black);
  /**
  * @prop --scrollbar-track: The color of the scrollbar track
  */
  --scrollbar-track: var(--lightGray);
  /**
  * @prop --scrollbar-thumb: The color of the scrollbar thumb
  */
  --scrollbar-thumb: var(--darkGray);
  display: block;
  /*TOOLTIP*/
  /*INDICATOR*/
  /*SCROLLBAR*/
  /* width */
  /* Track */
  /* Handle */
  /* Handle on hover */
}
:host #menu {
  background-color: var(--menu-background-color);
  font-family: var(--title-font-family);
  width: 240px;
  position: fixed;
  height: 100vh;
  inset-inline-start: 0;
  top: 0;
  z-index: 5;
}
:host #menu #title {
  text-transform: var(--title-text-transform);
  font-weight: var(--title-font-weight);
  color: var(--text-color);
  font-size: 14px;
  letter-spacing: 0.378px;
  padding: 16px;
  margin: 0;
  position: relative;
  z-index: 20;
  width: 240px;
  box-sizing: border-box;
}
:host #menu #title:before {
  content: "";
  position: absolute;
  width: 2px;
  height: 10px;
  background-color: var(--menu-background-color);
  inset-inline-start: 0;
  height: 100%;
  top: 0;
}
:host #menu #main {
  overflow-y: auto;
  position: fixed;
  width: 240px;
  z-index: 10;
}
:host #menu .text {
  color: var(--text-color);
}
:host #menu #footer {
  position: fixed;
  bottom: 0;
  inset-inline-start: 0;
  width: 240px;
  box-sizing: border-box;
  z-index: 20;
  font-size: var(--footer-font-size);
}
:host #menu #footer #custom-content {
  padding: 32px 16px 8px 16px;
  position: relative;
}
:host #menu #footer #custom-content:before {
  content: "";
  position: absolute;
  width: 2px;
  height: 10px;
  background-color: var(--menu-background-color);
  inset-inline-start: 0;
  height: 100%;
  top: 0;
}
:host #menu #footer #collapse-menu {
  cursor: pointer;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  transition: var(--menu-background-color) 0.25s;
  border-top: 1px solid var(--footer-line-color);
  transition: background-color 0.25s;
  position: relative;
}
:host #menu #footer #collapse-menu:hover {
  background-color: var(--item-hover-color);
}
:host #menu #footer #collapse-menu:hover:before {
  background-color: var(--item-hover-color);
}
:host #menu #footer #collapse-menu:active {
  background-color: var(--item-active-color);
}
:host #menu #footer #collapse-menu:active:before {
  background-color: var(--item-active-color);
}
:host #menu #footer #collapse-menu:before {
  content: "";
  position: absolute;
  width: 2px;
  height: 10px;
  background-color: var(--menu-background-color);
  inset-inline-start: 0;
  height: 100%;
  top: 0;
  transition: background-color 0.25s;
}
:host #menu.collapsed #footer #custom-content {
  display: none;
}
:host #menu.collapsed #footer #collapse-menu {
  padding: 0 10px;
}
:host #menu.collapsed, :host #menu.collapsed #title, :host #menu.collapsed #footer {
  inset-inline-start: -202px;
}
:host #menu.collapsing, :host #menu.collapsing #title, :host #menu.collapsing #footer {
  inset-inline-start: -240px !important;
  transition: left 0.6s;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
}
:host #menu.collapse-faster, :host #menu.collapse-faster #title, :host #menu.collapse-faster #footer {
  transition: left 0.3s;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
}
:host #menu.collapsed #collapse-menu {
  flex-direction: row-reverse;
}
:host #menu.collapsed #collapse-menu ch-icon {
  transform: rotate(180deg);
}
:host #menu.collapsed #collapse-menu .collapse-icon {
  transform: rotate(180deg);
}
:host #menu,
:host #footer {
  color: var(--text-color);
}
:host .tooltip {
  position: fixed;
  inset-inline-start: 50px;
  opacity: 0;
  transition: opacity 0.25s;
  background-color: var(--menu-background-color);
  color: var(--text-color);
  padding: 4px 8px;
  border-radius: 6px;
  z-index: 0;
}
:host .tooltip.visible {
  opacity: 1;
}
:host #indicator {
  width: 2px;
  background-color: var(--indicator-color);
  position: fixed;
  inset-inline-start: 0;
  height: 0;
  transition: top 0.4s, height 0.5s, opacity 0.35s;
  opacity: 1;
}
:host #indicator.speed-zero {
  transition-duration: 0s;
}
:host #indicator.hide {
  opacity: 0;
}
:host ::-webkit-scrollbar {
  width: 6px;
}
:host ::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
  border-radius: 3px;
}
:host ::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 3px;
}
:host ::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb);
  cursor: pointer;
}
:host .hidden-xs {
  visibility: hidden;
}
:host .visible-xs {
  visibility: inherit;
}